import React, { useState, useCallback, useEffect, useRef } from 'react';

import * as filterKeyMap from '@/pages/intelligence/components/Filter/FilterBase/_config';

import useFilterExtend from "@/pages/intelligence/hooks/useFilterExtend";
import Filter from '@/pages/intelligence/components/Filter';

import { Card } from 'tea-component';

export default function OpinionFilter(props: any) {
  const {
    filterConfirm,
    filterReset,
  } = props;

  const defaultValue = {
    [filterKeyMap.OPINION_SOURCEDATA_FULL]: { value: [] },
    [filterKeyMap.GAMETYPE_FULL]: { value: ['Mobile', 'PC', 'Console'] },
    [filterKeyMap.CHANNEL_TYPE_FULL]: { value: ['Game Store', 'Social Media', 'Streaming'] },
  };

  //继承逻辑在这写
  //formValue改成用ref，可提供给父组件回填时间， 或添加继承逻辑提供formValue给父组件
  const { filterExtend, setFilterExtend, resetFilterExtend } = useFilterExtend(
    {},
  );

  const extendDefaultValue = {
    [filterKeyMap.OPINION_SOURCEDATA_FULL]: { value: [] },
    [filterKeyMap.GAMETYPE_FULL]: { value: ['Mobile', 'PC', 'Console'] },
    [filterKeyMap.CHANNEL_TYPE_FULL]: { value: ['Game Store', 'Social Media', 'Streaming'] },
  };

  const formValueRef = useRef(extendDefaultValue);

  const companyRef = useRef();
  const gametypeRef = useRef();
  const servicetypeRef = useRef();

  const defaultInputList = {
    OPINION_SOURCEDATA_FULL: {
      key: filterKeyMap.OPINION_SOURCEDATA_FULL,
      default: defaultValue[filterKeyMap.OPINION_SOURCEDATA_FULL],
      ref: companyRef,
    },
    GAMETYPE_FULL: {
      key: filterKeyMap.GAMETYPE_FULL,
      default: defaultValue[filterKeyMap.GAMETYPE_FULL],
    },
    CHANNEL_TYPE_FULL: {
      key: filterKeyMap.CHANNEL_TYPE_FULL,
      default: defaultValue[filterKeyMap.CHANNEL_TYPE_FULL],
    },
  };

  const list = [];
  list.push(defaultInputList.OPINION_SOURCEDATA_FULL);
  list.push(defaultInputList.GAMETYPE_FULL);
  list.push(defaultInputList.CHANNEL_TYPE_FULL);

  const [inputList, setInputList] = useState(list);

  const onConfirm = useCallback(
    (value /**筛选器数据 */, apiValue /**筛选器转换后的数据 */) => {
      formValueRef.current = value;
      const filterForm = {
        source: value[filterKeyMap.OPINION_SOURCEDATA_FULL]?.value,
        game_type: value[filterKeyMap.GAMETYPE_FULL]?.value,
        channel_type: value[filterKeyMap.CHANNEL_TYPE_FULL]?.value,
      };
      filterConfirm(filterForm);
      setFilterExtend(apiValue);
    },
    [filterConfirm],
  );

  const onReset = useCallback(
    (value) => {
      formValueRef.current = {
        ...defaultValue,
      };
      companyRef?.current?.reset();
      gametypeRef?.current?.reset();
      servicetypeRef?.current?.reset();
      resetFilterExtend();
      if (filterReset instanceof Function) {
        filterReset();
      }
    },
    [filterReset],
  );

  // console.log('TEST FILTER 2', inputList, defaultValue)

  return (
    <Card>
      <Card.Body>
        <Filter
          value={formValueRef.current}
          inputList={inputList}
          onConfirm={onConfirm}
          onReset={onReset}
          defaultValue={defaultValue}
        />
      </Card.Body>
    </Card>
    
  );

}